import {useMutation, useQuery} from '@tanstack/react-query';
import {AxiosError} from 'axios';
import Api from 'configs';
import GetFilters from 'types/GetFilter';
import GetResponse from 'types/GetResponse';

export const useGetDetailUser = (id: string) => {
  return useQuery({
    queryKey: ['useGetDetailUser', id],
    queryFn: async () => {
      const {data} = await Api.get(`/admin/users/${id}`);
      return data;
    },
    enabled: !!id,
  });
};

export const useGetBanlance = (filters: GetFilters) => {
  const {pageSize = 10, page = 1, userID = ''} = filters;
  const options = {
    query: {},
    pageSize: pageSize,
    page: page,
  };
  return useQuery<GetResponse, AxiosError>({
    queryKey: ['useGetBalance', options, userID],
    queryFn: async () => {
      const {data} = await Api.get(`/admin/balance/${userID}`, {
        params: options,
      });
      return data;
    },
    staleTime: 1000 * 60 * 5,
    enabled: !!userID,
  });
};

interface ExportBalanceParams {
  userID: string;
  months: number;
}

export const useExportBalance = () => {
  return useMutation<Blob, AxiosError, ExportBalanceParams>({
    mutationFn: async ({userID, months}) => {
      const {data} = await Api.get(`/admin/balance/${userID}/export`, {
        params: {months},
        responseType: 'blob',
      });
      return data;
    },
  });
};
